import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import DataTable from "react-data-table-component"
import { Row } from "reactstrap"

const Applications = props => {
  const [applications, setapplications] = useState()

  var rows = []

  const fetchData = page => {
    props.paginate(page)
  }

  props.data.data.forEach(app => {
    // check whether application is draft
    if (app.application_status.id != 1) {
      let link = "#"
      if (app.service.id === 1) {
        link = (
          <Link
            className="btn btn-success"
            to={"/view-application?appId=" + app.id}
          >
            View
          </Link>
        )
        if (app.application_status.id === 7) {
          link = (
            <Link
              className="btn btn-warning"
              to={"/view-application?appId=" + app.id}
            >
              Edit
            </Link>
          )
        }
      } else if (app.service.id === 2) {
        link = (
          <Link
            className="btn btn-success"
            to={"/view-application-disposal?appId=" + app.id}
          >
            View
          </Link>
        )
        if (app.application_status.id === 7) {
          link = (
            <Link
              className="btn btn-warning"
              to={"/view-application-disposal?appId=" + app.id}
            >
              Edit
            </Link>
          )
        }
      }  else if (app.service.id === 3) {
        link = (
          <Link
            className="btn btn-success"
            to={"/view-application-export?appId=" + app.id}
          >
            View
          </Link>
        )
        if (app.application_status.id === 7) {
          link = (
            <Link
              className="btn btn-warning"
              to={"#"}
            >
              Edit
            </Link>
          )
        }
      } else if (app.service.id === 4) {
        link = (
          <Link
            className="btn btn-success"
            to={"/view-application-export?appId=" + app.id}
          >
            View
          </Link>
        )
        if (app.application_status.id === 7) {
          link = (
            <Link
              className="btn btn-warning"
              to={"/edit-license-application?appId=" + app.id}
            >
              Edit
            </Link>
          )
        }
      }

      var alertType = ""
      if (app.manually_processed != undefined && app.manually_processed == true && app.final_certificate_uploaded == null && app.application_status.id === 6) {
        alertType = "mt-2 alert alert-info"
      } else if (app.application_status.id === 6) {
        alertType = "mt-2 alert alert-success"
      } else if (app.application_status.id === 7) {
        alertType = "mt-2 alert alert-warning"
      } else if (app.application_status.id === 9) {
        alertType = "mt-2 alert alert-danger"
      } else {
        alertType = "mt-2 alert alert-info"
      }

      let status = ""
      console.log("app 2023 ---> ",app)
      if (app.manually_processed != undefined && app.manually_processed == true && app.final_certificate_uploaded == null && app.application_status.id === 6) {
        status = <div className={alertType}>Under Review</div>
      } else if (app.application_status.id === 6) {
        status = <div className={alertType}>Approved</div>
      } else if (app.application_status.id === 7) {
        status = <div className={alertType}>Returned</div>
      } else if (app.application_status.id === 9) {
        status = <div className={alertType}>Rejected</div>
      } else if (app.application_status.id === 2 && app.resubmitted ) {
        status = 
            <div className={alertType}>Re-Submitted </div>
      }
      else {
        status = <div className={alertType}>Under Review</div>
      }
      rows.push({
        app_id: app.app_id,
        type: app.service.name,
        status: status,
        date_created: app.created_at,
        date_submitted: app.submitted_at,
        action: link,
      })
    }
  })

  // Serverside pagination
  const columns = [
    {
      name: "ID",
      selector: "app_id",
    },
    {
      name: "Type",
      selector: "type",
    },
    {
      name: "Date Submitted",
      selector: "date_submitted",
    },
    {
      name: "Status",
      selector: "status",
    },
    {
      name: "Action",
      selector: "action",
    },
  ]

  return (
    <DataTable
      title="Your Applications"
      columns={columns}
      data={rows}
      highlightOnHover
      pagination
      paginationServer
      paginationTotalRows={props.data.total}
      paginationPerPage={props.data.per_page}
      paginationComponentOptions={{
        noRowsPerPage: true,
      }}
      onChangePage={page => fetchData(page)}
    />
  )
}

export default Applications
